// extracted by mini-css-extract-plugin
export default {"NotificationButton":"NotificationButton_NotificationButton__klltZ","White":"NotificationButton_White__gtrWc","NotificationCount":"NotificationButton_NotificationCount__k+RCZ"};